import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {

  transform(items: any, searchtxt?: any, colName: any =[]): any {
    if (!searchtxt){
      return items;
    }

    if (!Array.isArray(items)){
      return items;
    }

    searchtxt = searchtxt.toLowerCase();
    
    return items.filter((item) => {
      return colName.some((keyName) => {
        return new RegExp(searchtxt, 'gi').test(item[keyName.field]) || searchtxt == "";
      });

    
    });
  }

  // return item[colName].toLowerCase().includes(Q);

}
